module.exports = __webpack_public_path__ + "img/icon9.551839f0.png";